import { VISION_CAP_TILES, VISION_MARGIN_TILES } from "../vision/vision.ts";

/**
 * The limits emotes are held to (ADR-114 decisions 4.6, 6.4 and 6.5). An action is a Local line and counts in chat's
 * own limits (`chat/rules.ts`); the numbers here are the ones emotes add.
 */

/**
 * How many emoji one account may send in a window of `EMOJI_WINDOW_MS`, on a table of its own, so emoji never spend a
 * player's speech; past it an emoji is refused `rate` with the wait.
 */
export const EMOJI_PER_WINDOW = 4;

/**
 * The account's emoji window, in milliseconds.
 */
export const EMOJI_WINDOW_MS = 10_000;

/**
 * How many emoji the map server hands one listener in a second; past it an emoji is not sent to that listener, is
 * counted, and still reaches the others. This is the knob for a crowd.
 */
export const EMOJI_PER_LISTENER_SECOND = 10;

/**
 * How many actions one account may aim at the same player in a window of `TARGETED_ACTIONS_WINDOW_MS`, whatever the
 * actions; past it an action is refused `rate` with the wait. Creatures have no limit.
 */
export const TARGETED_ACTIONS_PER_TARGET = 3;

/**
 * The window of the limit per target, in milliseconds.
 */
export const TARGETED_ACTIONS_WINDOW_MS = 60_000;

/**
 * The most pairs of sender and target the limit per target holds at once; a full table refuses a pair it does not
 * hold.
 */
export const TARGETED_PAIRS_HELD = 4096;

/**
 * How far an emoji reaches, in tiles from a listener's feet on each axis: the listener's interest rectangle, half the
 * vision cap rounded up plus the server's lead outside it. A listener is sent an emoji when its sender stands within
 * this many tiles across and down.
 */
export const EMOJI_REACH_TILES: { readonly across: number; readonly down: number } = Object.freeze({
  across: Math.ceil(VISION_CAP_TILES.width / 2) + VISION_MARGIN_TILES,
  down: Math.ceil(VISION_CAP_TILES.height / 2) + VISION_MARGIN_TILES,
});
